import { render, staticRenderFns } from "./reboot-transceiver.vue?vue&type=template&id=222b46e0&"
import script from "./reboot-transceiver.vue?vue&type=script&lang=ts&"
export * from "./reboot-transceiver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports